import { Auth, Amplify } from "aws-amplify";
import "App.css";
import "responsive.css";
import Routes from "Routers/Routes";

import config from "./aws-exports";
import Maintenance from "UnderMaintenance";

const updatedAwsConfig = {
  ...config,
  // Set API to use id token. This will ensure email is passed within the token
  API: {
    graphql_headers: async () => ({
      Authorization: (await Auth.currentSession()).getIdToken().getJwtToken(),
    }),
  },
};

// Override the `blustreamREST` Amplify endpoint (used by polly services and
// any remaining legacy callers) via REACT_APP_API_BASE_URL. Removed once
// polly migrates off the proxy path. See spec docs/superpowers/specs/2026-05-21-client-api-module-design.md.
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
if (apiBaseUrl) {
  updatedAwsConfig.aws_cloud_logic_custom = (config.aws_cloud_logic_custom || []).map(
    (api) => api.name === "blustreamREST" ? { ...api, endpoint: apiBaseUrl } : api
  );
}

const REGEX = /.*-(\w+)/;
const env = config.aws_content_delivery_bucket.match(REGEX)[1];
if (env === "prod") {
  updatedAwsConfig["aws_user_files_s3_bucket"] =
    "live-s3-gandalf-contactcsvuploads";
}
Amplify.configure(updatedAwsConfig);

function App() {
  return (
    <>
      {process.env.REACT_APP_IS_UNDER_MAINTENANCE === "true" ? (
        <Maintenance />
      ) : (
        <Routes />
      )}
    </>
  );
}

export default App;
